import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

import { InterceptorErrorHandler, InterceptorRequestHandler } from "@api/interceptors/types";

export function setupResponseInterceptors(
  instance: AxiosInstance,
  errorHandlers: InterceptorErrorHandler[],
): void {
  instance.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
      for (const handler of errorHandlers) {
        try {
          await handler(error);
        } catch (handledError) {
          return Promise.reject(handledError);
        }
      }

      return Promise.reject(error);
    },
  );
}

export function setupRequestInterceptors(
  instance: AxiosInstance,
  requestHandlers: InterceptorRequestHandler[],
): void {
  instance.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      for (const handler of requestHandlers) {
        config = await handler(config);
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
}
